module.exports = __webpack_public_path__ + "img/bdwx.87cc3d61.png";